import { generateId } from '@freelancer/datastore/testing';
import {
  FolderApi,
  PrivacyLevelApi,
  ThreadTypeApi,
} from 'api-typings/messages/messages_types';
import { generateMessage, GenerateMessageOptions } from '../messages';
import { Thread, ThreadContext } from './threads.model';

export interface GenerateThreadsOptions {
  readonly id?: number;
  readonly userId: number;
  readonly otherMembers: readonly number[];
  readonly context: ThreadContext;
  readonly unreadMessageCount?: number;
  readonly message?: Omit<GenerateMessageOptions, 'threadId'>;
}

export function generateThread(options: GenerateThreadsOptions): Thread {
  const id = options.id ?? generateId();
  const messageUnreadCount = options.unreadMessageCount ?? 0;
  return {
    context: options.context,
    contextType: options.context.type,
    folder: FolderApi.INBOX,
    id,
    isBlocked: false,
    isFake: false,
    isMuted: false,
    isRead: messageUnreadCount === 0,
    members: [options.otherMembers[0], options.userId],
    inactiveMembers: [],
    message: options.message
      ? generateMessage({ ...options.message, threadId: id })
      : undefined,
    messageUnreadCount,
    otherMembers: [options.otherMembers[0]],
    owner: options.userId,
    threadType: ThreadTypeApi.PRIVATE_CHAT,
    timeCreated: Date.now(),
    timeRead: Date.now(),
    timeUpdated: Date.now(),
    userReadTimes: {
      [options.userId]: Date.now(),
      [options.otherMembers[0]]: Date.now(),
    },
    writePrivacy: PrivacyLevelApi.MEMBERS,
  };
}
